import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "es", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    // URL query has priority (for hreflang / social share targeting)
    const urlLang = new URLSearchParams(window.location.search).get("lang");
    if (urlLang === "en" || urlLang === "es") return urlLang;
    return window.localStorage.getItem("rp_lang") || "es";
  });

  useEffect(() => {
    window.localStorage.setItem("rp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
